import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndTone = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"type": "page",
			"properties": {
				"title": [
					[
						"Редполитика"
					]
				]
			},
			"content": [
				"932973be-4901-40be-a9f4-ce7e3642e0fd",
				"e6c8e200-e6f0-40e8-a29c-8950d892e3d5",
				"8b137b0e-4041-43af-82d4-66755b5e3ea9",
				"24788f60-bc83-4274-96a0-4a82b441653d",
				"6e57e609-8d2e-4b66-acf9-ad778ddec5f7",
				"c5e70c3b-bbf0-4d77-8d11-acacc751ca06",
				"731e6482-f1eb-46eb-abe6-77a137a44857",
				"ecc8bfd5-c735-4d73-b99f-c9dfbfd29736",
				"de8b6202-090f-4dcd-8eb2-de9005c93604",
				"04bf93cb-6496-43a0-88cb-17c62febab0d",
				"8d273325-281b-4fa5-a698-369db3ffcb98"
			],
			"format": {
				"social_media_image_preview_url": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c7299b99-a692-41b9-99dd-dc78687565fd/SocialMediaPreviewImage.png"
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"55a3cd8f-ae0b-4e6a-89f3-83960ac65b0b",
				"c7299b99-a692-41b9-99dd-dc78687565fd"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "932973be-4901-40be-a9f4-ce7e3642e0fd",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4c16f87a-99ff-4135-95f1-d7a506577667",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e6c8e200-e6f0-40e8-a29c-8950d892e3d5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Редполитика — свод правил для всех коммуникаций внутри экосистемы Mail: продуктовой, маркетинговой, PR. Задача редполитики — объединить наши интерфейсы в экосистему на уровне текстов. \n\nРедполитика разделена на несколько блоков: "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8b137b0e-4041-43af-82d4-66755b5e3ea9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Пишем чисто",
						[
							[
								"b"
							]
						]
					],
					[
						" — правила на уровне знаков, букв, типографики "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "24788f60-bc83-4274-96a0-4a82b441653d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Пишем просто",
						[
							[
								"b"
							]
						]
					],
					[
						" — правила на уровне базовых смыслов любой коммуникации "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e57e609-8d2e-4b66-acf9-ad778ddec5f7",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Пишем компетентно",
						[
							[
								"b"
							]
						]
					],
					[
						" — правила на уровне посылов, которые мы хотим донести "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5e70c3b-bbf0-4d77-8d11-acacc751ca06",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Пишем про человека и для него",
						[
							[
								"b"
							]
						]
					],
					[
						" — правила на уровне доступного языка "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "731e6482-f1eb-46eb-abe6-77a137a44857",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Правила интерфейсных текстов",
						[
							[
								"b"
							]
						]
					],
					[
						" — раздел с правилами для интерфейсных элементов: кнопок, ошибок, пустых состояний"
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ecc8bfd5-c735-4d73-b99f-c9dfbfd29736",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Глоссарий",
						[
							[
								"b"
							]
						]
					],
					[
						" — правила написания отдельных слов и фраз уникальных для языка Mail"
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de8b6202-090f-4dcd-8eb2-de9005c93604",
			"type": "text",
			"properties": {
				"title": [
					[
						"В каждом блоке — правила. В правиле — объяснение, исключения и примеры в формате «хорошо» и «плохо». "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "04bf93cb-6496-43a0-88cb-17c62febab0d",
			"type": "text",
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8d273325-281b-4fa5-a698-369db3ffcb98",
			"type": "text",
			"properties": {
				"title": [
					[
						"Обращайтесь к редполитике каждый раз, когда возникает вопрос про текст. "
					]
				]
			},
			"parent_id": "88cf99fd-dc9d-4649-8601-eb5198351e06",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": []
}} />
);

export default NotionVoiceAndTone;
